import {onFind} from "@elements/init-modules-in-scope";
import {on, findAllIn, findAll} from '@elements/dom-utils';
import Tab from 'bootstrap/js/dist/tab';

export function init () {
    onFind('.js-live-info-scroll-down', (baseElement) => {
        if(window.location.hash) {
            let tabTarget = window.location.hash.substring(1);
            let tabs = findAllIn('.js-live-info-scroll-down__tab', baseElement);
            let tabLink = tabs.find((tab) => tab.getAttribute('href') === '#' + tabTarget);
            if (tabLink) {
                window.scrollTo(0, tabLink.getBoundingClientRect().top + 200);
                Tab.getOrCreateInstance(tabLink).show();
            }
        }
    });
}